
$(document).ready(function(){
  
    $(".mobile #main_navigation li").click(function() {
        var collection = $(this).text();
      	if(collection=='Shop ▾'){
            //console.log('found:'+collection);
          if(!$('#shopmobilesubmenu').is(':visible')){
            $("#shopmobilesubmenu").slideDown();
          }else{
          	$("#shopmobilesubmenu").slideUp();
          }
        }
    });
  
  $("#mobilebrowsebygender").click(function() {
        if(!$('#mobilebrowsebygenderlinks').is(':visible')){
            $("#mobilebrowsebygenderlinks").slideDown();
          	$("#mobilebrowsebystylelinks").slideUp();
         }else{
          	$("#mobilebrowsebygenderlinks").slideUp();
         }
        
    });
  
   $("#mobilebrowsebystyle").click(function() {
        if(!$('#mobilebrowsebystylelinks').is(':visible')){
            $("#mobilebrowsebystylelinks").slideDown();
          	$("#mobilebrowsebygenderlinks").slideUp();
         }else{
          	$("#mobilebrowsebystylelinks").slideUp();
         }
        
    });
  	
  	$("#brandmobilesubmenu ul").slideUp();
  	$("#brandmobilesubmenu ul ul").slideUp();
    $(".brandmobilesubmenuchildclick").click(function(){
      if(!$(this).next("ul").is(':visible')){
        var el1 = $(this).next("ul");
        el1.slideDown();
        //$("#brandmobilesubmenu ul ul").slideUp();
        $("#brandmobilesubmenu ul ul").not(el1).slideUp();
      }else{
        $(this).next("ul").slideUp();
      }
    });  
  
  	$("#lookbookmobilesubmenu ul").slideUp();
  	
  	$("#lookbookmobilesubmenu ul").click(function(){
      $(this).slideDown();
    });  
  	$(".lookbookmobilesubmenu").click(function(){
      $(this).next("ul").slideUp();
    });  
  
  
  
  
  var windowwidth = $(window).width();
  if(windowwidth > 510){
    $("#showfilterbox").show();
  }
  if(windowwidth < 510){
    $("#showfilterbox").hide();
    
    $(".filtercol h3").click(function(){
    var iteration=$(this).data('iteration')||1
        switch ( iteration) {
            case 1:
                $("#showfilterbox").slideDown();
                break;
                
            case 2:
                $("#showfilterbox").slideUp();
                break;
        }
        iteration++;
        if (iteration>2) iteration=1
        $(this).data('iteration',iteration)
  });
  }
  
  /*
  $("nav.main li:nth-child(2), .shopmenu").hover(function() {
    $(".shopmenu").show();
  },function(){
    $(".shopmenu").hide();
  });
  */
  
  //$(".brandmenu").hide();
  
    $("nav.main li:nth-child(2), .brandmenu").hover(function() {
      $(".brandmenu").css('display','inline-grid');
    },function(){
      $(".brandmenu").hide();
    });
  
  $("nav.main li:nth-child(4), .lookbookmenu").hover(function() {
      $(".lookbookmenu").css('display','inline-grid');
    },function(){
      $(".lookbookmenu").hide();
    });
    
  
  $(".btnsg").click(function(){
    $("#showsg").show();
    $("#showindo,#showch,#showusa").hide();
  });
  
  $(".btnindo").click(function(){
    $("#showsg,#showch,#showusa").hide();
    $("#showindo").show();
  });
  
  $(".btnchina").click(function(){
    $("#showsg,#showindo,#showusa").hide();
    $("#showch").show();
  });
  
  $(".btnusa").click(function(){
    $("#showsg,#showindo,#showch").hide();
    $("#showusa").show();
  });
  
  /*$(".product .image").hover(function(){
    $(this).find(".hoverdetails").fadeIn();
  }, function() {
    $(this).find(".hoverdetails").fadeOut();
  });*/
  
  $(".mobilemenubtn").click(function(){
    var iteration=$(this).data('iteration')||1
        switch ( iteration) {
            case 1:
                $("nav.mobile").slideDown();
                break;
                
            case 2:
                $("nav.mobile").slideUp();
                break;
        }
        iteration++;
        if (iteration>2) iteration=1
        $(this).data('iteration',iteration)
  });
  
  /*blog entries page*/
  var $blogentries = $('#blogentries');
  // initialize
  $blogentries.masonry({
    columnWidth: 320,
    itemSelector: '.panels',
    "gutter": 0,
    "isFitWidth": true
  });
  
  /*product magnify*/
  $('#product .featured img').jqzoom({
    zoomType: 'innerzoom'
  });  
  
  /* blog hover */
  $(".mainexcerpt").hover(
    function() {
      $(this).find(".blogexcerpt").fadeIn();
    }, function() {
      $(this).find(".blogexcerpt").fadeOut();
    }
  );
  
  /* category hover */
  $(".bcategories").hover(
    function() {
      $(".btags").fadeIn();
    }, function() {
      $(".btags").fadeOut();
    }
  );
  
  /* filter hover 
  $(".pfilter").hover(
    function() {
      $(".showfilter").fadeIn();
    }, function() {
      $(".showfilter").fadeOut();
    }
  );
  $(".pfilterc").hover(
    function() {
      $(".showfilterc").fadeIn();
    }, function() {
      $(".showfilterc").fadeOut();
    }
  );*/
  
  /* archive click */
  $(".barchive").click(function() {
      $(".archivelist").fadeIn();
      $("#blog").hide();
    }
  );
  /*$("#btnbackblog").click(function() {
      $(".archivelist").hide();
      $("#blog").fadeIn();
    }
  );*/
  
  
$(function() {
    $( "#tabs" ).tabs();
  });


  $(".mailpop_trigger").click(function(){
    $(".mailpop_overlay").fadeIn();
  });
  
  $(".mailpop_close").click(function(){
    $(".mailpop_overlay").fadeOut();
  });  

  $("div.right_footer_link.grid__item > ul > li:nth-child(4)").click(function(){
    $("#mailing").fadeIn();
  });  
  
  /* back to top */
  $(".backtotop").click(function(){
    $("html, body").animate({ scrollTop: 0 }, "fast");
  });

  /*dropdown*/
  $('#currencies').easyDropDown({
      wrapperClass: 'dropdown'
  });
  
  /*$('#productselect, #quantity').easyDropDown({
      wrapperClass: 'metro'
  });*/
  
  /*$('#main_navigation').easyDropDown({
      wrapperClass: 'mmenu'
  });*/
  
  $('.coll-filter').easyDropDown({
      wrapperClass: 'flat'
  });
  
    
  $('#productscroll').infinitescroll({
    navSelector  : "ul.pagination",            
    nextSelector : "ul.pagination .next",    
    itemSelector : "#productscroll div.product", 
    loading: {
      finished: undefined,
      finishedMsg: "No more products to display.",
      img: "https://cdn.shopify.com/s/files/1/0422/3541/t/4/assets/loaderr.gif",
      msg: null,
      msgText: "",
      selector: null,
      speed: 'fast',
      start: undefined
    }
  });
  
  $('#journalscroll').infinitescroll({
    navSelector  : "ul.pagination",            
    nextSelector : "ul.pagination .next",    
    itemSelector : "#journalscroll div.mainexcerpt", 
    loading: {
      finished: undefined,
      finishedMsg: "No more entries to display.",
      img: "https://cdn.shopify.com/s/files/1/0422/3541/t/4/assets/loaderr.gif",
      msg: null,
      msgText: "",
      selector: null,
      speed: 'fast',
      start: undefined
    }
  }, function(newElements, data, url) { 
    
  $(".mainexcerpt").hover(
    function() {
      $(this).find(".blogexcerpt").fadeIn();
    }, function() {
      $(this).find(".blogexcerpt").fadeOut();
    }
  );
  });
  
  
  
  

  
   function addItem(form_id) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#'+form_id).serialize(),
        success: Shopify.onSuccess,
        error: Shopify.onError
      });
   }

   $(".addtocart").click(function(e){
   
      var elem = $(this)
      $(elem).prop("disabled", true)

      e.preventDefault();
      addItem('add-item-form');
     
   });
  
  $(".variantsadd1").click(function(e){
   
      var elem = $(this)
      $(elem).prop("disabled", true)

      e.preventDefault();
      addItem('variantsform1');
     
   });
  
  $(".variantsadd2").click(function(e){
   
      var elem = $(this)
      $(elem).prop("disabled", true)

      e.preventDefault();
      addItem('variantsform2');
     
   });
  
   Shopify.onSuccess = function() {
     
      var elem = $('.addtocart, .variantsadd1, .variantsadd2');
     
      elem.removeAttr("disabled");
     
      var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;

      function animate() {

        $("#cart-animation").show();

        var addtocartWidth = elem.outerWidth() / 2
        var addtocartHeight = elem.outerHeight() / 2

        var addtocartLeft = elem.offset().left + addtocartWidth;
        var addtocartTop = $(elem).offset().top + addtocartHeight ;

        var buttonAreaWidth = $("#cart-target").outerWidth();
        var buttonAreaHeight = $("#cart-target").outerHeight();

        var buttonAreaLeft = ($("#cart-target").offset().left + buttonAreaWidth / 2  - $("#cart-animation").outerWidth() / 2) - 4;
        var buttonAreaTop = ($("#cart-target").offset().top + buttonAreaWidth / 2  - $("#cart-animation").outerHeight() / 2) - 4 ;

        var path = {
          start: {
            x: addtocartLeft,
            y: addtocartTop,
            angle: 190.012,
            length: 0.2
          },
          end: {
            x: buttonAreaLeft,
            y: buttonAreaTop,
            angle: 90.012,
            length: 0.50
          }
        };
   
        $('#cart-animation').text(quantity).animate(
        {
          path : new $.path.bezier(path)
        },
        1200,
        function() {
          $("#cart-animation").fadeOut(500, function() {
            $(elem).prop("disabled", false)
            var cartCount =  parseInt($('#cart-count').text()) + quantity;
            $('#cart-count').text(cartCount)
          })
        }
        );
      }
   
      animate();
    };
  
    Shopify.onError = function(XMLHttpRequest, textStatus) {
      // Shopify returns a description of the error in XMLHttpRequest.responseText.
      // It is JSON.
      // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
      } else {
        alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
      }

      $('.addtocart').removeAttr("disabled");
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };

})

jQuery(window).load(function(){

  if ( $('.slides li').size() > 1 ) {

    /*$('.flexslider.homeslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: false,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').show();});*/
	
    $('.flexslider.lookbookslider').flexslider({
      animation: "slide",
      slideshow: false,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: false,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').show();});

  }

  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });

  
  var IE6 = false /*@cc_on || @_jscript_version < 5.7 @*/;
  if(IE6){
    if($("#placeholder img").width() > 360){
      $("#placeholder img").css('width', '360px');
    } else {
      $("#placeholder img").css('width', $("#placeholder img").width()+'px'); // restrict to initial width of image
    }
  } else {
    $("#placeholder img").css('maxWidth', $("#placeholder img").width()+'px'); // restrict to initial width of image
  }

  var pw = $("#placeholder img").width() + 8;
  $("#placeholder img").parents('div.featured').css('maxWidth', pw+'px'); // force IE to play nice
  
  
  var $container = $('#homecontainer');

  $container.imagesLoaded( function() {
    $container.masonry({
      columnWidth: function( containerWidth ) {
        return containerWidth / 4
      }
    });
  });
});

jQuery(document).ready(function($){
  
    /*$('a.fancybox-media').fancybox({
		openEffect  : 'none',
		closeEffect : 'none',
		helpers : {
			media : {}
		}
	});
  
  $("#cartpop").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  }).eq(0).trigger('click');*/
  
  

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });
   
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
  $('a[href^="#"]').bind('click.smoothscroll',function (e) {
	var target = this.hash,
        $target = $(target);
    
    
    
    if(target!='#lookbookmenu' && target!='#shopmenu'){
      e.preventDefault();
      $('html, body').stop().animate({
          'scrollTop': $target.offset().top
      }, 500, 'swing', function () {
          window.location.hash = target;
      });
    }else if(target=='#lookbookmenu'){
      if(!$("#lookbookmobilesubmenu ul").is(':visible')){
    	$("#lookbookmobilesubmenu ul").slideDown();
      }else{
      	$("#lookbookmobilesubmenu ul").slideUp();
      }
    }else if(target=='#shopmenu'){
      if(!$("#brandmobilesubmenu ul").is(':visible')){
    	$("#brandmobilesubmenu ul").slideDown();
      }else{
      	$("#brandmobilesubmenu ul").slideUp();
      }
    }
  });
  
  var tabs = $('ul.tabs > li > a');
  tabs.each(function(i) {
    jQuery(this).unbind('click.smoothscroll')
    .click(function(e) {
         var contentLocation = $(this).attr('href');
    	 if(contentLocation.charAt(0)=="#") {            
  		tabs.removeClass('active');
  		$(this).addClass('active');
  		$(contentLocation).show().addClass('active').siblings().hide().removeClass('active');
    	 }
      return false;
    });
  });
  
}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */
 
;(function($){
 
  $.path = {};
 
  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };
 
  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );
 
    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];
 
    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );
 
    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );
 
    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );
 
    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };
 
    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }
 
    this.dir = this.dir || 1;
 
    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }
 
    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }
 
    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};
 
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };
 
})(jQuery);

